/**
 * Create React App entry point. This and `public/index.html` files can not be
 * changed or moved.
 */
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import ReactDOM from "react-dom";
import axios from "axios";
import * as _redux from "./redux";
import store, { persistor } from "./redux/store";
import App from "./app/App";
import { setupAxiosInterceptors } from "./app/helpers/axiosInterceptor";
import "./index.scss"; // Standard version
// import "./sass/style.react.rtl.css"; // RTL version
import "./_metronic/_assets/plugins/keenthemes-icons/font/ki.css";
import "socicon/css/socicon.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "./_metronic/_assets/plugins/flaticon/flaticon.css";
import "./_metronic/_assets/plugins/flaticon2/flaticon.css";
// Datepicker
import "react-datepicker/dist/react-datepicker.css";
import {
  MetronicLayoutProvider,
  MetronicSplashScreenProvider,
  MetronicSubheaderProvider
} from "./_metronic/layout";
import {MetronicI18nProvider} from "./_metronic/i18n";

/**
 * Base URL of the website.
 *
 * @see https://facebook.github.io/create-react-app/docs/using-the-public-folder
 */
const { PUBLIC_URL } = process.env;

/**
 * Creates `axios-mock-adapter` instance for provided `axios` instance, add
 * basic Metronic mocks and returns it.
 *
 * @see https://github.com/ctimmerm/axios-mock-adapter
 */
/* const mock = */ 
// _redux.mockAxios(axios);

/**
 * Inject metronic interceptors for axios (OAuth2 Token).
 * Ini akan menambahkan Authorization: Bearer {token} header
 *
 * @see https://github.com/axios/axios#interceptors
 */
console.log('🔑 Initializing OAuth2 token interceptor...');
_redux.setupAxios(axios, store);
console.log('✅ OAuth2 token interceptor initialized!');

/**
 * Setup request signature interceptors untuk security
 * HMAC-SHA256 signature akan otomatis ditambahkan ke semua API requests
 * Interceptor ini jalan SETELAH OAuth2 token, jadi request akan punya:
 * - Authorization: Bearer {token} (dari setupAxios)
 * - X-Request-Signature & X-Request-Timestamp (dari setupAxiosInterceptors)
 */
console.log('🔐 Initializing request signature interceptors...');
setupAxiosInterceptors();
console.log('✅ Request signature interceptors initialized!');

ReactDOM.render(
  <MetronicI18nProvider>
    <MetronicLayoutProvider>
      <MetronicSubheaderProvider>
        <MetronicSplashScreenProvider>
          <App store={store} persistor={persistor} basename={PUBLIC_URL} />
        </MetronicSplashScreenProvider>
      </MetronicSubheaderProvider>
    </MetronicLayoutProvider>
  </MetronicI18nProvider>,
  document.getElementById("root")
);
